export const MagistratListStyle = {
  width: "100%",
};
